import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';
import { QUERY_KEYS } from '@/constants';
import { useReport } from '@/hooks';

export const useBangKePhieuXuatTraNCCExport = (queryParams?: MuaHangRecord) => {
  const { entity } = useAuth();
  const { getAll } = useReport({
    endpoint: QUERY_KEYS.BANG_KE_PHIEU_XUAT_TRA_LAI_NHA_CUNG_CAP
  });

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    try {
      const { exportBangKePhieuXuatTraNCCFromApi } = await import('../utils/export-excel');
      await exportBangKePhieuXuatTraNCCFromApi({
        entitySlug: entity.slug,
        queryParams,
        getAll
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug && queryParams)
  };
};
